// Action Types
const SET_USER = "user/SET_USER";
const LOGOUT_USER = "user/LOGOUT_USER";

// Initial State
const initialState = {
  full_name: "",
  email: "",
  mobile: "",
  city: "",
  province: "",
  ageRange: "",
};

// Action Creators
export const setUser = (userData) => ({
  type: SET_USER,
  payload: userData,
});

export const logoutUser = () => ({
  type: LOGOUT_USER,
});

// Reducer
export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        ...action.payload,
      };
    case LOGOUT_USER:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
